import React from 'react';

import {
  MultiAutocompleteTokenControl,
  useMultiAutocomplete,
  MultiSelectMenu,
  DefaultItem,
  UseMultiAutocompleteProps,
  RenderMenuItem,
} from '@adsk/alloy-react-dropdown';
import Footer, { ClearButton } from '@adsk/alloy-react-footer';

export type DropdownMultiSelectProps<T extends DefaultItem> =
  UseMultiAutocompleteProps<T> & {
    onClickClearSelectedOptions?: () => void;
    itemRenderer?: RenderMenuItem<T>;
    placeholder?: string;
  };

export const DropdownMultiSelect = <T extends DefaultItem>({
  onClickClearSelectedOptions,
  items: menuItems,
  selectedItems,
  onSelectedItemsChange,
  itemRenderer,
  placeholder,
}: DropdownMultiSelectProps<T>) => {
  const { controlProps, menuProps } = useMultiAutocomplete<T>({
    items: menuItems,
    selectedItems,
    onSelectedItemsChange: (event) => {
      onSelectedItemsChange && onSelectedItemsChange(event);
    },
  });

  const getInputPropsWithPlaceholder = (props: object | undefined) =>
    controlProps.getInputProps({ ...props, placeholder });

  return (
    <div>
      <MultiAutocompleteTokenControl
        {...controlProps}
        renderPlaceholder={() => placeholder}
        getInputProps={getInputPropsWithPlaceholder}
      />
      <MultiSelectMenu
        {...menuProps}
        renderMenuItem={itemRenderer}
        renderFooter={() =>
          onClickClearSelectedOptions ? (
            <Footer>
              <ClearButton onClick={onClickClearSelectedOptions} />
            </Footer>
          ) : null
        }
      />
    </div>
  );
};
